import { PageHeader, Section } from "@/components/site/PageChrome";
import { ArrowRight } from "lucide-react";

/* const posts = [
  { tag: "City Launch", date: "Dec 2025", t: "Time2Cash is coming to 5 new cities", d: "We're thrilled to announce our next wave of city launches, bringing local discovery to more communities across India.", tone: "#FFE4CC" },
  { tag: "Release Notes", date: "Dec 2025", t: "Smarter local matching & faster search", d: "Our latest update improves how quickly you find nearby help, jobs, and deals — with a cleaner, faster search experience.", tone: "#FED7AA" },
  { tag: "Feature", date: "Nov 2025", t: "Introducing the Shop Pro+ dashboard", d: "Business owners now get richer analytics on enquiries, customers, and performance to grow smarter.", tone: "#FFEDD5" },
  { tag: "Community", date: "Nov 2025", t: "1,000+ lives touched through Blood & SOS", d: "A milestone worth celebrating — our safety features are making a real difference in emergencies.", tone: "#FFE4CC" },
  { tag: "Maintenance", date: "Oct 2025", t: "Scheduled maintenance & reliability upgrades", d: "We rolled out backend improvements for a more stable, reliable Time2Cash experience.", tone: "#FED7AA" },
  { tag: "Announcement", date: "Oct 2025", t: "Ambassador Program goes nationwide", d: "Anyone can now apply to represent Time2Cash in their city and earn as they grow the community.", tone: "#FFEDD5" },
]; */

/* export default function BlogPage() {
  const [feature, ...rest] = posts;
  return (
    <>
      <PageHeader
        eyebrow="Blog & Updates"
        title="News from Time2Cash."
        subtitle="Company announcements, app updates, release notes, city launches, and community stories."
      />
      <Section>
        <a href="#" className="block rounded-[2rem] overflow-hidden border border-[#EBE8E3] bg-white hover:shadow-lg transition-shadow">
          <div className="grid md:grid-cols-2">
            <div className="h-56 md:h-auto" style={{ background: `linear-gradient(135deg, ${feature.tone}, #FF8A3D)` }} />
            <div className="p-8">
              <div className="flex items-center gap-3">
                <span className="rounded-full bg-[#FFF3ED] text-[#FF5A00] px-3 py-1 text-xs font-semibold">{feature.tag}</span>
                <span className="text-xs text-[#78716C]">{feature.date}</span>
              </div>
              <h2 className="mt-4 text-2xl md:text-3xl font-bold text-[#1A1918]">{feature.t}</h2>
              <p className="mt-3 text-[#4A4846] leading-relaxed">{feature.d}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-[#FF5A00] font-semibold">Read more <ArrowRight className="w-4 h-4" /></span>
            </div>
          </div>
        </a>

        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((p) => (
            <a key={p.t} href="#" className="rounded-3xl overflow-hidden border border-[#EBE8E3] bg-white hover:shadow-lg hover:-translate-y-1 transition-all">
              <div className="h-40" style={{ background: `linear-gradient(135deg, ${p.tone}, #FFC078)` }} />
              <div className="p-6">
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-[#FFF3ED] text-[#FF5A00] px-3 py-1 text-xs font-semibold">{p.tag}</span>
                  <span className="text-xs text-[#78716C]">{p.date}</span>
                </div>
                <h3 className="mt-3 text-lg font-bold text-[#1A1918]">{p.t}</h3>
                <p className="mt-2 text-sm text-[#4A4846] leading-relaxed">{p.d}</p>
              </div>
            </a>
          ))}
        </div>
      </Section>
      <Newsletter />
    </>
  );
} */
export default function BlogPage() {
  /*
  const [feature, ...rest] = posts;
  */

  return (
    <>
      <PageHeader
        eyebrow="Blog & Updates"
        title="Coming Soon"
        subtitle="We're working on bringing you the latest Time2Cash news, feature updates, city launches, product announcements, and community stories."
      />

      <Section>
        <div className="max-w-3xl mx-auto text-center rounded-[2rem] border border-[#EBE8E3] bg-white p-12 shadow-sm">
          <div className="w-20 h-20 mx-auto rounded-full bg-[#FFF3ED] flex items-center justify-center text-4xl">
            📰
          </div>

          <h2 className="mt-6 text-4xl font-bold text-[#1A1918]">
            Blog & Updates Coming Soon
          </h2>

          <p className="mt-4 text-lg text-[#4A4846] leading-relaxed">
            Soon you'll find product announcements, release notes, city
            expansion updates, feature launches, maintenance notices, and
            exciting stories from the Time2Cash community—all in one place.
          </p>

          <div className="mt-8 inline-flex items-center rounded-full bg-[#FFF3ED] px-5 py-2 text-sm font-semibold text-[#FF5A00]">
            🚀 Stay Tuned
          </div>
        </div>

        {/*
        <a>...</a>

        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          ...
        </div>

        <Newsletter />
        */}
      </Section>
    </>
  );
}